import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import { useForm } from 'react-hook-form';
import { reduxFormResolver } from '#helper/rhf-resolver';
import { resetPassword } from '#action/user/settings';
import RHFTextField from '#component/form/rhf/rhf-text-field';
import { whitelabel } from '#config/whitelabel';
import {
  ButtonsContainer,
  CompanyImgCnt,
  CompanyImgLogo,
  DivPaper,
  ForgotPasswordMain,
  ForgotPasswordText,
  StyledForm,
  StyledH5
} from '#component/user/auth-challenge/styles';
import validate from './validate';
import propTypes from './prop-types';
import { setDocumentTitle } from '#helper';

const Form = props => {
  useEffect(() => {
    setDocumentTitle('Restore password');
  }, []);

  const { control, handleSubmit, formState: { isSubmitting } } = useForm({
    resolver: reduxFormResolver(validate),
    defaultValues: { email: '' }
  });

  const handleFormSubmit = values => {
    const { email } = values;
    const { resetPassword: dispatchResetPassword } = props;

    return dispatchResetPassword({ email });
  };

  const {
    match: { params: { sent } },
    history
  } = props;

  return (
    <ForgotPasswordMain>
      <CssBaseline />
      <DivPaper>
        <CompanyImgCnt>
          <CompanyImgLogo
            src={whitelabel.buildAssetUrl('media/logo.svg')}
            alt="logo"
          />
        </CompanyImgCnt>
        <StyledH5 component="h1" variant="h5">
          Restore password
        </StyledH5>
        <ForgotPasswordText variant="body2">
          {!sent ?
            'Please enter your email and we will send you a link to restore your password.' :
            "If an account exists for that email, we've sent a link to set a new password. Please check your mailbox, including your spam folder."}
        </ForgotPasswordText>
        {!sent && (
          <StyledForm
            onSubmit={handleSubmit(handleFormSubmit)}
            autoComplete="on"
          >
            <RHFTextField
              name="email"
              control={control}
              label="Email"
              variant="outlined"
              fullWidth
              margin="normal"
            />
            <ButtonsContainer>
              <Button
                variant="outlined"
                onClick={() => history.push('/login')}
              >
                Cancel
              </Button>
              <Button
                disabled={isSubmitting}
                type="submit"
                variant="contained"
                color="secondary"
              >
                Restore
              </Button>
            </ButtonsContainer>
          </StyledForm>
        )}
      </DivPaper>
    </ForgotPasswordMain>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    resetPassword: data => dispatch(resetPassword(data))
  };
}

Form.propTypes = propTypes;

export default connect(null, mapDispatchToProps)(Form);
